import type { PropsWithChildren } from "react";

import { gameModules } from "../games/registry";
import { usePreferences } from "./preferencesContext";

interface AppShellProps extends PropsWithChildren {
  selectedGame?: string;
  onGameChange?: (game: string) => void;
}

export function AppShell({ children, selectedGame = "all", onGameChange }: AppShellProps) {
  const { antiSpoiler, setAntiSpoiler } = usePreferences();
  const changeGame = (game: string) => {
    if (onGameChange) onGameChange(game);
    else window.location.assign(`/tournaments${game === "all" ? "" : `?game=${game}`}`);
  };
  return (
    <div className="app-shell" data-game={selectedGame}>
      <header className="app-header">
        <a className="brand" href="/">
          <span className="brand-mark" aria-hidden="true">F</span>
          <span>FasterPedia</span>
        </a>
        <nav aria-label="Primary navigation">
          <a href="/">Results</a>
          <a href="/watchlist">Watchlist</a>
          <a href="/tournaments">Tournaments</a>
        </nav>
        <div className="header-controls"><label className="spoiler-toggle"><input type="checkbox" checked={antiSpoiler} onChange={(event) => setAntiSpoiler(event.target.checked)} /><span>Anti-spoiler</span></label><label className="game-switcher-label">
          <span>Game</span>
          <select value={selectedGame} onChange={(event) => changeGame(event.target.value)} aria-label="Current game">
            <option value="all">All games</option>
            {gameModules.map((game) => (
              <option key={game.id} value={game.id}>{game.name}</option>
            ))}
          </select>
        </label></div>
      </header>
      <main>{children}</main>
    </div>
  );
}
